/*
* @描述: 更换负责人
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2024-12-06 16:59:48
*/
<template>
    <el-dialog :before-close="handleDialogClose"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :visible.sync="dialogVisible"
               title="更换负责人"
               width="520px">
        <el-form ref="changePersonForm"
                 :model="changePersonForm"
                 :rules="changePersonFormRules"
                 class="team_members_form"
                 label-position="top"
                 size="small">
            <el-form-item label="选择人员" prop="salesperson">
                <el-select v-model="changePersonForm.salesperson"
                           :remote-method="getUserOptions"
                           filterable
                           placeholder="请选择人员，可输入人员姓名搜索"
                           remote>
                    <el-option v-for="item in userOptions"
                               :key="item.uid"
                               :label="item.name"
                               :value="item.uid"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button @click="handleDialogClose">取消</el-button>
            <el-button type="primary" @click="handleDialogConfirm">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
    import {GetUserList, projectSalespersonChange} from "@/api";

    export default {
        name: "BusinessAddMember",
        data() {
            return {
                changePersonForm: {
                    salesperson: '',
                },
                changePersonFormRules: {
                    salesperson: [
                        {required: true, message: '请选择人员', trigger: 'change'}
                    ]
                },
                userOptions: [],
            }
        },
        props: {
            dialogVisible: {
                type: Boolean,
                default: false,
            },
            project_ids: {
                type: Array,
                default: () => []
            }
        },
        created() {
            this.getUserOptions()
        },
        methods: {
            //获取用户列表
            getUserOptions(keyword) {
                GetUserList({keyword}).then(res => {
                    if (res.code === 200) {
                        this.userOptions = res.data || []
                    } else {
                        this.$toast(res.message)
                    }
                })
            },

            // 关闭弹窗
            handleDialogClose() {
                this.$emit('update:dialogVisible', false)
            },

            // 确定
            handleDialogConfirm() {
                this.$refs.changePersonForm.validate(valid => {
                    if (valid) {
                        projectSalespersonChange({
                            project_ids: this.project_ids,
                            salesperson: this.changePersonForm.salesperson,
                        }).then(res => {
                            if (res.code === 200) {
                                this.$message.success('更换成功')
                                this.$emit('update:dialogVisible', false)
                                this.$emit('refresh')
                            } else {
                                this.$toast(res.message)
                            }
                        })
                    } else {

                    }
                })
            },
        },
    }
</script>
<style lang="scss" scoped>
  .team_members_form {
    padding-bottom: 106px;

    .el-select {
      width: 100%;
    }
  }
</style>